import { Employee } from "domain/entities/employee";
import { Parameter } from "domain/entities/parameter";
import { EmployeeInputFilter } from "domain/models/employee-input-filter";
import DropdownComponent from "presentation/components/Shared/DropdownComponent";
import InputDateComponent from "presentation/components/Shared/InputDateComponent";
import { useEmployeesByFilter } from "presentation/hooks/use-query-employees";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import "../index.css";
import InvoiceGrid from "../InvoiceGrid";

interface InvoiceAdminParams {
  date: Date;
  employee: Employee;
}

const InvoiceAdmin: React.FC = () => {
  const toast = useRef<Toast>(null);

  const { data: employeesData, refetch: refetchEmployees } = useEmployeesByFilter({ justCPS: true, limit: 100, isActive: true } as EmployeeInputFilter);
  const [employees, setEmployees] = useState<Parameter[]>();
  const [invoiceAdminParameters, setInvoiceAdminParameters] =
    useState<InvoiceAdminParams>();

  const [employeeToAnalyse, setEmployeeToAnalyse] = useState<Parameter>();

  useEffect(() => {
    const formatedEmployees = employeesData?.data?.map((item) => {
      const employee: Parameter = {
        id: item.id,
        value: item.name,
        type: "employee",
      };
      return employee;
    });

    const allEmployeesOption: Parameter = {
      id: "todos",
      value: "TODOS",
      type: "employee",
    };

    setEmployees([allEmployeesOption, ...(formatedEmployees ?? [])]);
  }, [employeesData]);

  useEffect(() => {
    if (invoiceAdminParameters?.employee) {
      const empToAnalyse: Parameter = {
        id: invoiceAdminParameters.employee.id,
        value: invoiceAdminParameters.employee.name,
        type: "employee",
      };
      setEmployeeToAnalyse(empToAnalyse);
    }
  }, [invoiceAdminParameters?.employee]);

  return (
    <div className="timesheet-grid ">
      <div className="timesheet-2-cols">
        <DropdownComponent
          options={employees ?? []}
          label="Colaborador"
          isValueId={true}
          fieldName="employee"
          currentObject={invoiceAdminParameters}
          getValue={invoiceAdminParameters?.employee?.id || null}
          setValue={setInvoiceAdminParameters}
        />
      </div>

      <div className="timesheet-1-col">
        <InputDateComponent
          label="Data"
          fieldName="date"
          currentObject={invoiceAdminParameters}
          getValue={invoiceAdminParameters?.date}
          setValue={setInvoiceAdminParameters}
          view="month"
          dateFormat="yy/mm"
        />
      </div>


      <div className="timesheet-4-cols">
        {invoiceAdminParameters?.employee &&
          invoiceAdminParameters?.date &&
          invoiceAdminParameters?.employee.id !== "todos" && (
            <InvoiceGrid
              externalFilters={{
                employeeId: employeeToAnalyse?.id ?? "",
                invoiceMonth: invoiceAdminParameters?.date
                  ? new Date(invoiceAdminParameters?.date).getMonth() + 1
                  : undefined,
                invoiceYear: invoiceAdminParameters?.date
                  ? new Date(invoiceAdminParameters?.date).getFullYear()
                  : undefined,
                sortBy: "createdAt",
                sortOrder: "desc",
              }}
              hideAddInvoice={true}
            />
          )}

        {invoiceAdminParameters?.employee &&
          invoiceAdminParameters?.date &&
          invoiceAdminParameters?.employee.id === "todos" && (
            <InvoiceGrid
              externalFilters={{
                employeeId: "*",
                invoiceMonth: invoiceAdminParameters?.date
                  ? new Date(invoiceAdminParameters?.date).getMonth() + 1
                  : undefined,
                invoiceYear: invoiceAdminParameters?.date
                  ? new Date(invoiceAdminParameters?.date).getFullYear()
                  : undefined,
                sortBy: "employee.name",
                sortOrder: "asc",
              }}
              hideAddInvoice={true}
            />
          )}
      </div>

      <Toast ref={toast} position="bottom-right" />

    </div>
  );
};
export default InvoiceAdmin;
